export { default } from './DirectionPad'
